import type { FieldErrorProps } from '@/components/field-error/field-error.types';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import FormSchema from '@/utils/form-schema';
import '@/components/field-error/field-error-v1.css';
import '@/components/field-error/field-error-v2.css';

export default function FieldError(props: FieldErrorProps) {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const errors = useAppSelector(ConfigSlice.selectors.signFormErrors);

  if (!props.on) return null;

  const message = props.issues.map((issue) => FormSchema.message(issue, errors)).find(Boolean);

  if (!message) return null;

  return (
    <div data-css-version={cssVersion} className='field-error'>
      {message}
    </div>
  );
}
